import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-100 p-4 text-center text-xs text-gray-500" data-id="element-38">
      <div className="max-w-4xl mx-auto mt-16 text-sm text-gray-700" data-id="element-39">
        <h3 className="font-semibold mb-4" data-id="element-40">Scientific Citations</h3>
        <ol className="list-decimal pl-5 space-y-3" data-id="element-41">
          <li data-id="element-42">
            Reynolds, Lisa A., <em data-id="element-43">et al.</em> "Managing Cat Allergens: Fel d 1
            Environmental and Immunological Control Measures."{' '}
            <em data-id="element-44">Journal of Feline Medicine and Surgery</em>, vol. 21, no. 11,
            2019, pp. 1046–1053.{' '}
            <a href="https://doi.org/10.1177/1098612X19861218" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-45">
              https://doi.org/10.1177/1098612X19861218
            </a>
          </li>
          <li data-id="element-46">
            Dyson Newsroom. "The Truth About Pet Hair and Allergens." Dyson, 21
            Apr. 2022.{' '}
            <a href="https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-47">
              https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens
            </a>
          </li>
          <li data-id="element-48">
            AchooAllergy. "Facts about Animal Dander and Allergies." 2023.{' '}
            <a href="https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-49">
              https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/
            </a>
          </li>
          <li data-id="element-50">
            Gong, Tao, <em data-id="element-51">et al.</em> "Cat Allergens: Diagnosis and
            Immunotherapy."{' '}
            <em data-id="element-52">Clinical Reviews in Allergy &amp; Immunology</em>, vol. 63, no.
            1, 2021, pp. 58–74. PubMed Central (PMC).{' '}
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-53">
              https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/
            </a>
          </li>
          <li data-id="element-54">
            "Struggle to Snuggle: The Impact of Cat Allergens on Cat Owners."
            DVM360, 6 Dec. 2018.{' '}
            <a href="https://www.dvm360.com/view/struggle-to-snuggle-the-impact-of-cat-allergens-on-cat-owners" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-55">
              https://www.dvm360.com/view/struggle-to-snuggle-the-impact-of-cat-allergens-on-cat-owners
            </a>
          </li>
          <li data-id="element-56">
            Dyson Newsroom (2022) and AchooAllergy (2023). Combined sources on
            HEPA limitations and ongoing filter costs.{' '}
            <a href="https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-57">
              Dyson article
            </a>{' '}
            ·{' '}
            <a href="https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-58">
              AchooAllergy article
            </a>
          </li>
          <li data-id="element-59">
            Reynolds, L. A., <em data-id="element-60">et al.</em> (2019) and Gong, T.,{' '}
            <em data-id="element-61">et al.</em> (2021). Environmental allergen control and particle
            aggregation mechanisms supporting ion-mediated agglomeration.{' '}
            <a href="https://doi.org/10.1177/1098612X19861218" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-62">
              Reynolds 2019
            </a>{' '}
            ·{' '}
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-63">
              Gong 2021
            </a>
          </li>
          <li data-id="element-64">
            National Institute for Occupational Safety and Health (NIOSH), U.S.
            CDC. "Ozone Generators and Indoor Air Quality." 2022. Guidance on
            avoiding ozone-generating devices; modern consumer ionisers marketed
            as ozone-safe should meet applicable safety limits.{' '}
            <a href="https://www.cdc.gov/niosh/topics/indoorenv/ozone.html" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-65">
              https://www.cdc.gov/niosh/topics/indoorenv/ozone.html
            </a>
          </li>
        </ol>
      </div>
      <div className="text-center text-xs text-gray-500 mt-12" data-id="element-66">
        <p data-id="element-67">© 2025 Petssey. All Rights Reserved.</p>
        <p data-id="element-68">
          Results may vary. This is an advertorial and not an actual news
          article.
        </p>
      </div>
    </footer>;
};